// extracted by mini-css-extract-plugin
export default {"divider":"ModalActions_divider__Sds+n","actions":"ModalActions_actions__weZIR"};